import { render, staticRenderFns } from "./public-footer.vue?vue&type=template&id=25ba7a46&scoped=true&"
import script from "./public-footer.vue?vue&type=script&lang=js&"
export * from "./public-footer.vue?vue&type=script&lang=js&"
import style0 from "./public-footer.vue?vue&type=style&index=0&id=25ba7a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba7a46",
  null
  
)

export default component.exports